// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6u-4";
export var collapsed = "_6u-1";
export var headerBar = "_6u-0";
export var leftHeaderContent = "_6u-3";
export var subjectContainer = "_6u-2";